/**
 * ============================================
 * APP.TSX - Componente Principal
 * ============================================
 *
 * Configura los providers globales y el Router.
 * - I18nextProvider: Traducciones (debe estar arriba de todo)
 * - AuthProvider: Maneja estado de autenticación
 * - RouterProvider: Sistema de navegación
 *
 * IMPORTANTE: El orden de los providers importa.
 * I18nextProvider debe envolver todo para que useTranslation()
 * funcione en cualquier componente, incluyendo páginas del router.
 */

import { RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { router } from "./routes";
import { AuthProvider, SucursalProvider } from "./contexts";
import { Toaster } from "./components/ui/sonner";
import { ErrorBoundary } from "./components/error-boundary";
import i18n from "./lib/i18n";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary>
        <AuthProvider>
          <SucursalProvider>
            <RouterProvider router={router} />
            <Toaster position="top-right" richColors closeButton />
          </SucursalProvider>
        </AuthProvider>
      </ErrorBoundary>
    </I18nextProvider>
  );
}

export default App;
